<template>
  <div class="table-responsive mt-3 mb-0">
    <table class="table table-bordered custom-table mb-0">
      <thead class="thead-light">
        <tr>
          <th>Sunday</th>
          <th>Monday</th>
          <th>Tuesday</th>
          <th>Wednesday</th>
          <th>Thursday</th>
          <th>Friday</th>
          <th>Saturday</th>
        </tr>
      </thead>
      <tbody>
        <!-- First Row -->
        <tr v-if="firstRowDates && firstRowDates.length">
          <td
            v-for="(item, i) in firstRowDates"
            :key="'firstRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.StartTime }}
              </span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /First Row -->

        <!-- Second Row -->
        <tr v-if="secondRowDates && secondRowDates.length">
          <td
            v-for="(item, i) in secondRowDates"
            :key="'secondRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">{{
                rec.StartTime
              }}</span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Second Row -->

        <!-- Third Row -->
        <tr v-if="thirdRowDates && thirdRowDates.length">
          <td
            v-for="(item, i) in thirdRowDates"
            :key="'thirdRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">{{
                rec.StartTime
              }}</span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Third Row -->

        <!-- Fourth Row -->
        <tr v-if="fourthRowDates && fourthRowDates.length">
          <td
            v-for="(item, i) in fourthRowDates"
            :key="'fourthRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.StartTime }}
              </span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Fourth Row -->

        <!-- Fifth Row -->
        <tr v-if="fifthRowDates && fifthRowDates.length">
          <td
            v-for="(item, i) in fifthRowDates"
            :key="'fifthRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">{{
                rec.StartTime
              }}</span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Fifth Row -->

        <!-- Sixth Row -->
        <tr v-if="sixthRowDates && sixthRowDates.length">
          <td
            v-for="(item, i) in sixthRowDates"
            :key="'sixthRow' + i"
            @dblclick="showAddEvent(item, $event)"
            @click.right="showAddMenu(i, item, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Events"
              :key="rec.Id"
              :style="'background-color:' + rec.Color"
              :class="
                rec.Id == selectedEventId ? 'event-div selected' : 'event-div'
              "
              @click="selectEvent(rec, $event)"
              @dblclick="showEditEvent(rec, $event)"
              @click.right="showEditMenu(i, rec, $event)"
            >
              <span class="event-span">
                {{ formatEventName(rec.EventName, rec.IsPublicHoliday) }}
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">{{
                rec.StartTime
              }}</span>
              <!-- Menu for right click -->
              <div
                tabindex="-1"
                class="card m-0 menu"
                :id="'editMenu' + rec.Id"
                :ref="'editMenu' + rec.Id"
                :style="`top:${top};left:${left};display:none`"
                @blur="closeEditMenu(rec.Id)"
              >
                <div class="card-body p-0">
                  <div @click="showEditEvent(rec, $event)" class="menu-item">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </div>
                  <div @click="remove(rec.Id, $event)" class="menu-item">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </div>
                </div>
              </div>
              <!-- /Menu for right click -->
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Sixth Row -->
      </tbody>
    </table>

    <!-- Add-Edit Event Modal -->
    <div class="modal custom-modal fade" id="addEvent" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">{{ id ? "Edit" : "Add" }} Event</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="save">
              <div class="form-group">
                <label class="mb-0">
                  Event Name<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  v-model="eventName"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label class="mb-0">Location</label>
                <input
                  type="text"
                  v-model="location"
                  class="form-control"
                  maxlength="100"
                />
              </div>
              <div class="form-group">
                <label class="mb-0">
                  Date<span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  v-model="date"
                  required
                />
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      Start Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="startHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="startMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="startTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6 mb-0">
                    <label class="mb-0">
                      End Time<span class="text-danger">*</span>
                    </label>
                    <div class="d-flex align-items-center">
                      <select
                        v-model="endHour"
                        class="form-control form-control-sm fit-content"
                        required
                      >
                        <option value>0</option>
                        <option
                          v-for="item in timingHours"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <span class="mx-1">:</span>
                      <select
                        v-model="endMinute"
                        class="form-control form-control-sm fit-content"
                      >
                        <option
                          v-for="item in timingMinutes"
                          :value="item"
                          :key="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                      <select
                        v-model="endTimePart"
                        class="form-control form-control-sm ml-2 fit-content"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="mb-0">Notes</label>
                <textarea
                  class="form-control"
                  maxlength="200"
                  v-model="notes"
                ></textarea>
              </div>
              <!-- Button -->
              <div class="submit-section mt-4">
                <button type="submit" class="btn btn-primary submit-btn">
                  {{ id ? "Update" : "Add" }}
                </button>
              </div>
              <!-- /Button -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add-Edit Event Modal -->

    <!-- Add Menu Right Click -->
    <div
      tabindex="-1"
      class="card m-0 menu"
      id="addMenu"
      ref="addMenu"
      :style="`top:${top};left:${left};display:none`"
      @blur="closeAddMenu"
    >
      <div class="card-body p-0">
        <div @click="showAddEvent(null, $event)" class="menu-item">
          <i class="fa fa-plus-circle mr-1"></i>Add Event
        </div>
      </div>
    </div>
    <!-- /Add Menu Right Click -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import $ from "jquery";
export default {
  props: ["selectedDate", "instructorId", "selectedCountries"],
  data() {
    return {
      firstRowDates: [],
      secondRowDates: [],
      thirdRowDates: [],
      fourthRowDates: [],
      fifthRowDates: [],
      sixthRowDates: [],
      //for modal
      id: "",
      eventName: "",
      location: "",
      date: "",
      startHour: "",
      startMinute: "00",
      startTimePart: "AM",
      endHour: "",
      endMinute: "00",
      endTimePart: "AM",
      notes: "",
      country: "",
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
      selectedEventId: "",
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
    todayDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
  },

  methods: {
    //modal add and edit
    showAddEvent(payload, event) {
      event.preventDefault();
      this.id = "";
      this.eventName = "";
      this.location = "";
      if (payload && payload.CalendarDate) this.date = payload.CalendarDate;
      this.startHour = "";
      this.startMinute = "00";
      this.startTimePart = "AM";
      this.endHour = "";
      this.endMinute = "00";
      this.endTimePart = "AM";
      this.notes = "";
      $("#addMenu").hide();
      // $("#addEvent").modal("show");
      let obj = {
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
      };
      this.$emit("showAddEventFromComponent", obj);
    },
    showEditEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload.IsPublicHoliday) {
        let obj = {
          eventName: payload.EventName,
          date: payload.DateStartDisplay,
          country: payload.Country,
        };
        this.$emit("showPublicHoliday", obj);
        return;
      }
      this.id = payload.Id;
      this.eventName = payload.EventName;
      this.location = payload.Location;
      this.date = payload.CalendarDate;
      this.startHour = payload.StartHour;
      this.startMinute = payload.StartMinute.toString().padStart(2, "0");
      this.startTimePart = payload.StartTimePart;
      this.endHour = payload.EndHour;
      this.endMinute = payload.EndMinute.toString().padStart(2, "0");
      this.endTimePart = payload.EndTimePart;
      this.notes = payload.Notes;
      $(`#editMenu${payload.Id}`).hide();
      // $("#addEvent").modal("show");
      let obj = {
        id: this.id,
        eventName: this.eventName,
        location: this.location,
        date: this.date,
        startHour: this.startHour,
        startMinute: this.startMinute,
        startTimePart: this.startTimePart,
        endHour: this.endHour,
        endMinute: this.endMinute,
        endTimePart: this.endTimePart,
        notes: this.notes,
      };
      this.$emit("showEditEventFromComponent", obj);
    },
    showMore(payload, event) {
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      this.$emit("showMore", payload.CalendarDate);
    },
    selectEvent(payload, event) {
      if (!payload.IsPublicHoliday) {
        this.selectedEventId = payload.Id;
        this.$emit("selectEvent", payload);
      }
    },
    //helper
    formatEventName(val, isPh) {
      if (!val) return "";
      let maxChars = isPh ? 27 : 16;
      let output = val;
      if (val.length > maxChars) {
        output = val.substring(0, maxChars - 3) + "...";
      }
      return output;
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    stopPropagation(event) {
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
    },
    //menu add and edit
    showAddMenu(colIndex, payload, event) {
      event.preventDefault();
      this.date = payload.CalendarDate;
      this.$nextTick(() => {
        $(document).scrollTop(this.scrollTop);
      });
      $("#addMenu").show();
      this.$refs.addMenu.focus();
      let calDivOuterHeight = $(".cal-div").outerHeight();
      let calDivOuterWidth = $(".cal-div").outerWidth();
      if (calDivOuterHeight >= 300) {
        calDivOuterHeight = 0;
      } else {
        calDivOuterHeight = calDivOuterHeight + 20;
        calDivOuterWidth = 0;
      }
      let allAboveElementsHeight =
        60 + 30 + 36.2 + 30 + 20 + 42.41 + 16 + calDivOuterHeight;
      let top = event.y + this.scrollTop - allAboveElementsHeight;

      let sideBarOuterWidth = $(".sidebar").outerWidth();
      let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
      let addMenuOuterWidth = $(".menu").outerWidth();
      let left =
        event.x -
        (allLeftElementsWidth + (colIndex == 6 ? addMenuOuterWidth + 20 : 0));
      this.top = top + "px";
      this.left = left + "px";
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    showEditMenu(colIndex, payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload.IsPublicHoliday) return;
      this.selectedEventId = payload.Id;
      this.$emit("selectEvent", payload);
      $(`#editMenu${payload.Id}`).show();
      this.$refs[`editMenu${payload.Id}`][0].focus();
      //adjust position
      let editMenuOuterWidth = $(".menu").outerWidth();
      let eventDivOuterWidth = $(".event-div").outerWidth();
      let top = 0;
      let left =
        colIndex == 6
          ? eventDivOuterWidth - editMenuOuterWidth
          : eventDivOuterWidth;
      this.top = top + "px";
      this.left = left + "px";
    },
    closeEditMenu(id) {
      $(`#editMenu${id}`).hide();
    },
    //main function
    getEventByMonth() {
      let param = {
        Token: this.tokenObj.Token,
        InstructorId: this.instructorId,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
      };
      API.schedule
        .getEventByMonth(param)
        .then((response) => {
          if (response.data.success) {
            let records = response.data.data;
            this.loadCalendar(records);
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    loadCalendar(records) {
      this.firstRowDates = [];
      this.secondRowDates = [];
      this.thirdRowDates = [];
      this.fourthRowDates = [];
      this.fifthRowDates = [];
      this.sixthRowDates = [];
      let index = 0;
      //populate first row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].DayOfWeek == dayOfWeek) {
          if (records[index].Events && records[index].Events.length > 6) {
            records[index].MoreCount = records[index].Events.length - 5;
            records[index].Events.splice(
              records[index].Events.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.firstRowDates.push(records[index]);
          index++;
        } else {
          this.firstRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Events: [],
          });
        }
      }
      //populate second row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Events && records[index].Events.length > 6) {
          records[index].MoreCount = records[index].Events.length - 5;
          records[index].Events.splice(
            records[index].Events.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.secondRowDates.push(records[index]);
        index++;
      }
      //populate third row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Events && records[index].Events.length > 6) {
          records[index].MoreCount = records[index].Events.length - 5;
          records[index].Events.splice(
            records[index].Events.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.thirdRowDates.push(records[index]);
        index++;
      }
      //populate fourth row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Events && records[index].Events.length > 6) {
          records[index].MoreCount = records[index].Events.length - 5;
          records[index].Events.splice(
            records[index].Events.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.fourthRowDates.push(records[index]);
        index++;
      }
      //populate fifth row
      if (!Object.prototype.hasOwnProperty.call(records, index)) return;
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (Object.prototype.hasOwnProperty.call(records, index)) {
          if (records[index].Events && records[index].Events.length > 6) {
            records[index].MoreCount = records[index].Events.length - 5;
            records[index].Events.splice(
              records[index].Events.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.fifthRowDates.push(records[index]);
          index++;
        } else {
          this.fifthRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Events: [],
          });
        }
      }
      //populate sixth row
      if (!Object.prototype.hasOwnProperty.call(records, index)) return;
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (Object.prototype.hasOwnProperty.call(records, index)) {
          if (records[index].Events && records[index].Events.length > 6) {
            records[index].MoreCount = records[index].Events.length - 5;
            records[index].Events.splice(
              records[index].Events.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.sixthRowDates.push(records[index]);
          index++;
        } else {
          this.sixthRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Events: [],
          });
        }
      }
    },
    save() {
      //validation
      if (
        (this.startHour != "" || this.startMinute != "") &&
        (this.endHour != "" || this.endMinute != "")
      ) {
        let startHour = this.startHour != "" ? parseInt(this.startHour) : 0;
        let startMinute =
          this.startMinute != "" ? parseInt(this.startMinute) : 0;
        let totalStartTimeMinutes =
          (this.startTimePart == "AM"
            ? startHour == 12
              ? 0
              : startHour
            : startHour < 12
            ? startHour + 12
            : 12) *
            60 +
          startMinute;

        let endHour = this.endHour != "" ? parseInt(this.endHour) : 0;
        let endMinute = this.endMinute != "" ? parseInt(this.endMinute) : 0;
        let totalEndTimeMinutes =
          (this.endTimePart == "AM"
            ? endHour == 12
              ? 0
              : endHour
            : endHour < 12
            ? endHour + 12
            : 12) *
            60 +
          endMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //save
      let param = {
        Token: this.tokenObj.Token,
        Id: this.id,
        EventName: this.eventName,
        Location: this.location,
        CalendarDate: this.date,
        StartHour: this.startHour,
        StartMinute: this.startMinute,
        StartTimePart: this.startTimePart,
        EndHour: this.endHour,
        EndMinute: this.endMinute,
        EndTimePart: this.endTimePart,
        Notes: this.notes,
      };
      API.schedule
        .saveEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByMonth();
            $("#addEvent").modal("hide");
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    remove(id, event) {
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      API.schedule
        .deleteEvent(param)
        .then((response) => {
          if (!response.data.success)
            this.$swal(response.data.message, { icon: "error" });
          if (response.data.success) {
            this.getEventByMonth();
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getEventByMonth();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
  },
};
</script>

<style scoped>
.table-responsive {
  position: relative;
}
table {
  table-layout: fixed;
}
.table.custom-table > tbody > tr > td {
  padding-left: 3px !important;
  padding-right: 3px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  vertical-align: top !important;
  height: 125px;
  cursor: pointer;
}
.day-div {
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  height: 25px;
  display: flex;
}
.circle {
  color: #fff;
  width: 22px;
  height: 22px;
  background-color: #3884cc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1px;
}
.event-div {
  opacity: 1;
  margin-bottom: 1px;
  padding-left: 2px;
  padding-right: 2px;
  cursor: pointer;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  width: 100%;
  letter-spacing: -0.5px;
  position: relative;
}
.event-div:hover {
  opacity: 1;
}
.event-span {
  color: white;
  font-size: 10px;
  width: 100%;
}
.time-span {
  color: white;
  font-size: 9px;
  width: 40px;
  text-align: right;
  padding-top: 2px;
}
.more-div {
  font-size: 10px;
  color: grey;
}
.table th {
  text-align: center;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
.selected {
  border: 2px solid black;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/Other/MyCalendarMonth.vue